import { ThemeOptions } from "@mui/material";

const typography: ThemeOptions['typography']= {
  fontFamily: "WorkSans-Medium",
  h1: {
    fontSize: "24px",
    lineheight: "32px",
    fontFamily: "WorkSans-SemiBold",
  },
  h2: {
    fontSize: "20px",
    lineheight: "26px",
    fontFamily: "WorkSans-Medium",
  },
  h3: {
    fontSize: "18px",
    lineheight: "24px",
    fontFamily: "WorkSans-Medium",
  },
  h4: {
    fontSize: "16px",
    lineheight: "20px",
    fontFamily: "WorkSans-Medium",
  },
  h5: {
    fontSize: "14px",
    lineheight: "18px",
    fontFamily: "WorkSans-Medium",
  },
  h6: {
    fontSize: "12px",
    lineheight: "16px",
    fontFamily: "WorkSans-SemiBold",
  },
  subtitle1: {
    fontSize: "16px",
    lineheight: "20px",
    fontFamily: "WorkSans-Medium",
  },
  subtitle2: {
    fontSize: "14px",
    lineheight: "16px",
    fontFamily: "WorkSans-Medium",
  },
  body1: {
    fontSize: "14px",
    lineheight: "16px",
    fontFamily: "WorkSans-Regular",
  },
  body2: {
    fontSize: "12px",
    lineheight: "14px",
    fontFamily: "WorkSans-Regular",
  }
}

export default typography;

